//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";

export default {
	name: 'Filters',
	props: {},
	data() {
		return {
			filters: null,
			filterTagArray: []
		}
	},
	computed: {
		...mapGetters(["listingsData"]),
	},
	methods: {
		...mapActions(["setFilterTags", "setFilteredListings"]),
		addFilterTag(e, i) {
			let selectParent = e.target.closest(".filters__select-custom");
			if (e.target.value !== "") {
				selectParent.classList.remove("empty");
			} else {
				selectParent.classList.add("empty");
			}
			this.filterTagArray[i] = e.target.value;
		},
		applyFilters() {
			let tagValues = [];
			for (let i = 0; i < this.filterTagArray.length; i++) {
				if (this.filterTagArray[i] && this.filterTagArray[i] !== "") {
					tagValues.push(this.filterTagArray[i]);
				}
			}
			this.setFilterTags(tagValues);
			this.setFilteredListings();
		},
		clearFilters(e) {
			let listingParent = e.target.closest(".listing-app");
			let selectInputs = [...listingParent.querySelectorAll(".filters__dropdowns select")];
			selectInputs.forEach(select => {
				let selectParent = select.closest(".filters__select-custom");
				select.value = "";
				selectParent.classList.add("empty");
			});
			this.filterTagArray = [];
			this.setFilterTags([]);
			this.setFilteredListings();
		}
	},
	mounted() {
		this.filters = this.listingsData.filters;
	}
}
